// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1qF7t","select":"Header_select__1ZkOb","clinic":"Header_clinic__2gjUO"};